import React from 'react'
import { useSelector } from 'react-redux'
import { selectors as ConfigSelectors } from 'data/config'

import { providesChannelMutations } from 'components/Channels/dataSync'
import ModalBody from 'components/Utils/Modal/Body'

import PublicSharingForm from './PublicSharingForm'
import ChannelPermisionsForm from '../Memberships/ChannelPermissionsForm'

export type ChannelsSettingsSharingProps = {
  channel: any
  publiclyShareChannel: (options: { id: string }) => void
  publiclyUnshareChannel: (options: { id: string }) => void
}

export default providesChannelMutations(function ChannelsSettingsSharing({
  channel,
  publiclyShareChannel,
  publiclyUnshareChannel,
}: ChannelsSettingsSharingProps) {
  const showPermissionsForms = useSelector(state =>
    ConfigSelectors.hasFlag(state, 'merge-share-and-permissions')
  )

  return (
    <ModalBody style={{ minWidth: 600 }}>
      <PublicSharingForm
        channel={channel}
        publiclyShareChannel={publiclyShareChannel}
        publiclyUnshareChannel={publiclyUnshareChannel}
      />
      {showPermissionsForms && (
        <React.Fragment>
          <div className="margin-bottom-larger" />
          <ChannelPermisionsForm channelId={channel.id} />
        </React.Fragment>
      )}
    </ModalBody>
  )
})
